export enum TypeOfCuisine {
  POLISH = 'Polish',
  CHINESE = 'Chinese',
  AMERICAN = 'American',
  VIETNAMESE = 'Vietnamese',
  ITALIAN = 'Italian',
  MEXICAN = 'Mexican',
  INDIAN = 'Indian',
  JAPANESE = 'Japanese',
  THAI = 'Thai',
  FRENCH = 'French',
  GREEK = 'Greek',
  KOREAN = 'Korean',
  MIXED = 'Mixed'
}